import { Link } from '@tanstack/react-router'
import styled from 'styled-components'
import { IconV2 } from 'ui/components'
import { CSS } from 'ui/helpers/cssHelpers'

export const WrappedIcon = styled(IconV2)`
  margin-right: 8px;
`

const UniqueItem = styled(Link)`
  color: var(--theme-colors-global-general-secondary) !important;
  text-align: left;
  white-space: nowrap;
  cursor: pointer;
  display: flex;
  align-items: center;
  text-decoration: none;
  font: var(--theme-typography-bodyL-regular);
  height: 40px;
  min-width: 224px;
  padding-left: 12px;
  padding-right: 12px;

  &:hover {
    background-color: var(--theme-colors-global-grey-grey100);
  }

  transition: ${CSS.populateTransition(['background-color'], '0.25s')};

  &:focus-visible,
  &:focus-within {
    outline: none;
    border: none;
  }
`

const BaseItem = styled(UniqueItem)`
  font: var(--theme-typography-bodyL-semiBold);
  color: var(--theme-colors-global-grey-grey900) !important;

  ${WrappedIcon} {
    color: var(--theme-colors-global-grey-grey700);
  }
`

export const DeleteItem = styled(BaseItem)`
  ${WrappedIcon} {
    color: var(--theme-colors-theme-negative-main);
  }
`

export const DetailsItem = styled(BaseItem)``

export const HistoryItem = styled(BaseItem)``

export const EditItem = styled(BaseItem)``

export const Item = styled(UniqueItem)`
  padding-left: 44px;
`

export const ItemWithIconNeutral = styled(UniqueItem)`
  ${WrappedIcon} {
    color: var(--theme-colors-global-grey-grey700);
  }
`

export const ItemWithIconPositive = styled(UniqueItem)`
  ${WrappedIcon} {
    color: var(--theme-colors-theme-brand-primary);
  }
`

export const ItemWithIconNegative = styled(UniqueItem)`
  ${WrappedIcon} {
    color: var(--theme-colors-theme-negative-main);
  }
`
